import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import '@progress/kendo-angular-intl/locales/es/all';
import { KendoUIModule } from '@shared/modules';
import { NgxFileDropModule } from 'ngx-file-drop';
import { SharedComponents } from './components';
import { SharedDirectives } from './directives';
import { CustomDatePipe, SharedPipes } from './pipes';

@NgModule({
  declarations: [...SharedComponents, ...SharedDirectives, ...SharedPipes],
  exports: [
    CommonModule,
    DatePipe,
    FormsModule,
    KendoUIModule,
    ReactiveFormsModule,
    RouterModule,
    ScrollingModule,
    ...SharedComponents,
    ...SharedDirectives,
    ...SharedPipes,
    TranslateModule,
  ],
  imports: [
    CommonModule,
    FormsModule,
    KendoUIModule,
    NgxFileDropModule,
    ReactiveFormsModule,
    RouterModule,
    ScrollingModule,
    TranslateModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es' },
    DatePipe,
    CurrencyPipe,
    CustomDatePipe,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class SharedModule {}
